/* eslint-disable react/prop-types */
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { ukUA } from '@mui/x-date-pickers/locales';

import { t } from '../i18n/translations';
import usePickerLogic from '../hooks/usePickerLogic';
import { Container, Language, GoBack, GoBackLink } from './Picker.styles';
import BookingForm from './BookingForm';
import BookingSummary from './BookingSummary';

export default function MaterialUIPickers() {
    const state = usePickerLogic();
    const {
        show, setShow, lang,
        handleChangeLanguage,
    } = state;

    return (
        <LocalizationProvider
            dateAdapter={AdapterDayjs}
            adapterLocale={lang === 'ua' ? 'uk' : 'en'}
            localeText={lang === 'ua' ? ukUA.components.MuiLocalizationProvider.defaultProps.localeText : 'en'}
        >
            {/* Language switcher */}
            {show !== 'Checkout' && (
                <Language item alignItems="flex-end">
                    <FormControl size="small">
                        <InputLabel id="lang-label">{t(lang, 'language')}</InputLabel>
                        <Select value={lang} label={t(lang, 'language')} onChange={handleChangeLanguage}>
                            <MenuItem value="ua">🇺🇦</MenuItem>
                            <MenuItem value="en">🇺🇸</MenuItem>
                        </Select>
                    </FormControl>
                </Language>
            )}

            {/* Main widget */}
            {show === 'Tool' && (
                <Container container>
                    <BookingForm  {...state} />
                    <BookingSummary {...state} />
                </Container>
            )}

            {/* Legacy Monobank redirect back link */}
            {show === 'Checkout' && (
                <GoBack onClick={() => setShow('Tool')}>
                    <GoBackLink>⬅ {t(lang, 'goBack')}</GoBackLink>
                </GoBack>
            )}
            <div id="checkout-container" style={show === 'Tool' ? { display: 'none' } : { display: 'block' }} />
        </LocalizationProvider>
    );
}
